export const SETTINGS_KEY = "ALL_PRODUCTS_CATEGORY_MAPPING";

export const getProductUniqueId = (product) =>
  product.product_principal_id || product.product_id;

export const groupProducts = (products, mapping) => {
  const groupedProducts = {};

  // Pre-initialize sections in mapping key order to preserve backend sorting
  Object.keys(mapping).forEach((section) => {
    groupedProducts[section] = [];
  });

  products.forEach((product) => {
    const productId = getProductUniqueId(product);

    const matchedSection = Object.keys(mapping).find((section) =>
      mapping[section]?.includes(productId)
    );

    if (matchedSection) {
      groupedProducts[matchedSection].push(product);
    }
  });

  // Remove empty sections
  Object.keys(groupedProducts).forEach((key) => {
    if (groupedProducts[key].length === 0) {
      delete groupedProducts[key];
    }
  });

  return groupedProducts;
};

export const getProductSection = (productId, mapping) => {
  return (
    Object.keys(mapping).find((section) =>
      mapping[section]?.includes(productId)
    ) || "Others"
  );
};

export const filterProducts = (groupedProducts, searchQuery) => {
  if (!searchQuery || !searchQuery.trim()) return groupedProducts;

  const query = searchQuery.toLowerCase().trim();
  const filtered = {};

  Object.entries(groupedProducts).forEach(([section, products]) => {
    const sectionMatches = section.toLowerCase().includes(query);

    const matchingProducts = products.filter((product) => {
      const name = product?.medicine?.display_name?.toLowerCase() || "";
      const description = product?.medicine?.description?.toLowerCase() || "";
      return sectionMatches || name.includes(query) || description.includes(query);
    });

    if (matchingProducts.length > 0) {
      filtered[section] = matchingProducts;
    }
  });

  return filtered;
};
